import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function ServiceTime(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.serviceTime.label}>
      <preview.DurationValue format="DURATION_HH_MM">
        {extOrder.orderStep.serviceTimeSec}
      </preview.DurationValue>
    </preview.Field>
  )
}
